// src/Pages/GMS/ISR/Components/hooks/useCategoryUpdate.ts

import { TField, TSubmodel, TProductCategory, TConnector, TUpsertISRProjectDataModelsInput, TIndexState } from '../../Pages/DefineModel/model';

type CategoryUpdateHookReturn = {
    updateCategoryField: <K extends keyof TProductCategory['data']>(
        fieldName: K,
        value: TProductCategory['data'][K]
    ) => void;
};

export const useCategoryUpdate = (
    selectedItem: TField | TSubmodel | TProductCategory | TConnector | null,
    userProjectDataModels: TUpsertISRProjectDataModelsInput,
    setUserProjectDataModels: React.Dispatch<React.SetStateAction<TUpsertISRProjectDataModelsInput>>,
    indexInfo: TIndexState
): CategoryUpdateHookReturn => {

    const updateCategoryField = <K extends keyof TProductCategory['data']>(
        fieldName: K,
        value: TProductCategory['data'][K]
    ) => {
        const productCategory = selectedItem as TProductCategory;

        setUserProjectDataModels((prevDataModels) => {
            const newDataModels = { ...prevDataModels };

            if (productCategory && productCategory?.data?.belongsToDataModel) {
                // Update category inside data model
                const dataModelToUpdate = newDataModels.project.dataModels[indexInfo?.dataModelIndex ?? -1];
                if (dataModelToUpdate && dataModelToUpdate.data && dataModelToUpdate.data.productCategories[indexInfo?.categoryIndex ?? -1]) {
                    const categoryData = dataModelToUpdate.data.productCategories[indexInfo.categoryIndex ?? -1].data;

                    // Special handling for 'required' field with minQuantity and minCount
                    if (fieldName === 'required' && typeof value === 'boolean') {
                        const minQuantity = value && categoryData.minQuantity === 0 ? 1 : !value && categoryData.minQuantity === 1 ? 0 : categoryData.minQuantity;
                        const minCount = value && categoryData.minCount === 0 ? 1 : !value && categoryData.minCount === 1 ? 0 : categoryData.minCount;
                        dataModelToUpdate.data.productCategories[indexInfo.categoryIndex ?? -1].data.minQuantity = minQuantity ?? 0;
                        dataModelToUpdate.data.productCategories[indexInfo.categoryIndex ?? -1].data.minCount = minCount ?? 0;
                    }

                    // @ts-ignore - Dynamic field assignment
                    dataModelToUpdate.data.productCategories[indexInfo.categoryIndex ?? -1].data[fieldName] = value;
                }
            } else {
                // Update category outside data model
                const fieldToUpdate = newDataModels.project.productCategories[indexInfo?.fieldOutsideDataModelIndex ?? -1];
                if (fieldToUpdate && fieldToUpdate.data) {
                    // @ts-ignore - Dynamic field assignment
                    fieldToUpdate.data[fieldName] = value;
                }
            }

            return newDataModels;
        });
    };

    return { updateCategoryField };
};
